import React, { Component } from 'react'
import { View, TouchableOpacity, Text } from '@shoutem/ui'

const CircleButton = ({ onPress, sign }) => (
  <TouchableOpacity onPress={onPress} style={styles.circle}>
    <View style={styles.bubble}>
      <Text style={styles.letter}>{sign}</Text>
    </View>
  </TouchableOpacity>
)

export class Stepper extends Component {
  increment = () => {
    const { max, onValueChange, initialValue } = this.props

    if (initialValue < max)
      onValueChange && onValueChange(Math.min(initialValue + 1, max))
  }

  decrement = () => {
    const { min, onValueChange, initialValue } = this.props

    if (initialValue > min)
      onValueChange && onValueChange(Math.max(initialValue - 1, min))
  }

  render() {
    const {
      min,
      max,
      onValueChange,
      initialValue,
      containerStyle,
      label
    } = this.props
    return (
      <View styleName="horizontal" style={{ ...styles.row, ...containerStyle }}>
        <Text
          style={{
            fontSize: 16,
            // marginHorizontal: 10,
            fontWeight: 'bold',
            color: '#000'
          }}
        >
          {initialValue}
          {label}
        </Text>
        <CircleButton sign="-" onPress={this.decrement} />
        <CircleButton sign="+" onPress={this.increment} />
      </View>
    )
  }
}

const styles = {
  bubble: {
    height: 30,
    width: 30,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 15,
    // marginLeft: 15,
    borderColor: '#ffd200',
    borderWidth: 2,
    backgroundColor: '#fff'
  },
  activeBubble: {
    backgroundColor: '#ffd200',
    borderColor: '#ffd200'
  },
  activeText: {
    // color: '#fff'
  },
  circle: {
    marginLeft: 10
  },
  letter: {
    fontWeight: 'bold',
    fontSize: 16,
    color: '#000'
  },
  row: { flexDirection: 'row', alignItems: 'center' }
}

export default Stepper



// WEBPACK FOOTER //
// ./src/components/Stepper.js